<div id="gridConfigValidationDiv" class="grid-container">
  <!--Testata configurazione colonne-->
  <dx-data-grid
    id="gridStyle"
    [allowColumnResizing]="true"
    [dataSource]="gridConf.styleConditions"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
    [showBorders]="false"
    [showColumnLines]="true"
    [showRowLines]="true"
    (onRowUpdated)="onConfigRowUpdating($event)"
    [height]="(windowSize.contentHeight ?? 0) - tabsHeight"
    (onToolbarPreparing)="hideButtons($event)"
    (onEditingStart)="saveData()"
    (onSelectionChanged)="saveData()"
  >
    <dxi-column
      dataField="value1"
      [caption]="'Primo valore' | siaTranslate"
      width="150"
      alignment="left"
    >
    </dxi-column>

    <dxi-column
      dataField="operator"
      width="150px"
      [caption]="'Operatore' | siaTranslate"
      alignment="center"
    >
      <dxo-lookup [dataSource]="operators" displayExpr="name" valueExpr="id">
      </dxo-lookup>
    </dxi-column>

    <dxi-column
      dataField="value2"
      [caption]="'Secondo valore' | siaTranslate"
      alignment="left"
      width="150"
    ></dxi-column>

    <dxi-column
      dataField="cssStyle"
      [caption]="'Stile CSS' | siaTranslate"
      alignment="left"
    >
    </dxi-column>

    <dxi-column
      dataField="area"
      [caption]="'Area' | siaTranslate"
      alignment="left"
      width="100"
    >
      <dxo-lookup
        [dataSource]="gridConfAreaTypes"
        displayExpr="name"
        valueExpr="id"
      >
      </dxo-lookup>
    </dxi-column>

    <dxi-column
      dataField="column"
      [caption]="'Colonna' | siaTranslate"
      [width]="150"
      alignment="left"
    >
      <dxo-lookup [dataSource]="tempCols"></dxo-lookup>
    </dxi-column>

    <dxo-editing
      mode="batch"
      refreshMode="repaint"
      [allowUpdating]="true"
      [allowDeleting]="true"
      [allowAdding]="true"
      [selectTextOnEditStart]="selectTextOnEditStart"
      [startEditAction]="startEditAction"
    >
    </dxo-editing>

    <dxo-selection mode="single"></dxo-selection>
    <dxo-remote-operations [sorting]="true" [paging]="true">
    </dxo-remote-operations>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
    <dxo-load-panel [enabled]="false"></dxo-load-panel>
    <dxo-header-filter [visible]="false"></dxo-header-filter>
    <dxo-filter-row [visible]="false"></dxo-filter-row>
    <dxo-search-panel [visible]="false"></dxo-search-panel>
    <dxo-group-panel [visible]="false"></dxo-group-panel>
    <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
  </dx-data-grid>
</div>
